/** Keep only a short prefix and suffix visible; never reveal short secrets. */
export const maskSecret = (value = '') => {
  const secret = String(value || '');
  if (!secret) return '';
  if (secret.length <= 8) return '••••••••';
  return `${secret.slice(0, 4)}${'•'.repeat(secret.length - 8)}${secret.slice(-4)}`;
};
